import React, { useState, useEffect } from "react";
import { connect } from "react-redux";

import { createInventory } from "../../../../../Actions/stakeholderActions";

import { useVehicles } from "./hooks/useVehicles";
import { useGeolocationContext } from "../../Geolocation/hooks/geolocationContext";

import ModalRoutes from "../../../ModalRoutes";
import Navbar from "../../../../Navbar";

import { VehicleFilters } from "./VehicleFilters";
import { VehicleOverviewTopSection } from "./VehicleOverviewTopSection";

import { SearchBar } from "./SearchBar";
import { VehiclesList } from "./VehiclesTable/VehiclesList";
import { InventoryList } from "../../OrderStatus/InventoryList";
import { EmptyState } from "./EmptyState";

const VehicleOverview = (props) => {
  const {
    vehicles,
    searching,
    loading: loadingVehicles,
    vehiclesCountTotal,
    vehicleFiltersData,
    searchFilters,
    setSearchFilters,
    searchTerm,
    setSearchTerm,
    searchOnScroll,
    startExport,
    sortFilters,
    updateSorting,
  } = useVehicles(props);

  const addVehicle = () => {
    props.history.push(props.match.url + "/vehicle/New");

    if (inventoryClientCode) {
      props.dispatch(createInventory());
    }
  };


  const { vehicles: gpsDeviceVehicles, getGeolocationData } = useGeolocationContext();

	useEffect(() => {
		if (!gpsDeviceVehicles?.length) {
			getGeolocationData();
		}
	}, []);

  document.title = 'Vehicle Overview - FleetXPress'

  return (
    <div className="bkg-white-dark listviewnew">
      <Navbar history={props.history} match={props.match} location={props.location} />

      <VehicleOverviewTopSection {...{ startExport, addVehicle }} />

      <div className="list-container">
        <div className="list-wrapper">

          <VehicleFilters
            vehicles={vehicles}
            vehiclesCountTotal={vehiclesCountTotal}
            vehicleFiltersData={vehicleFiltersData}
            searchFilters={searchFilters}
            setSearchFilters={setSearchFilters}
          />

          <div className="mainsection">
            <div className="searchbar-section actions-section">
              <div className="left" style={{ paddingTop: '5px' }}>
                <SearchBar {...{ searching, searchTerm, setSearchTerm }} />
              </div>
            </div>

            <div onScroll={searchOnScroll}>
              {loadingVehicles || vehicles?.length > 0 ? (
                <VehiclesList
                  vehicles={vehicles}
                  loading={loadingVehicles}
                  sortBy={sortFilters.sortBy}
                  sortOrder={sortFilters.sortOrder}
                  updateSorting={updateSorting}
                  {...props}
                />
              ) : (
                <EmptyState />
              )}
            </div>
          </div>
        </div>
      </div>

      <ModalRoutes match={props.match} history={props.history} />
    </div>
  );
};

const mapStateToProps = (store) => ({
  userSession: store.userSession,
  data: store.data,
  settings: store.settings,
  stakeholder: store.stakeholder,
});

export default connect(mapStateToProps)(VehicleOverview);
